import React, { useState, useRef } from "react";
import { Input, Button } from "@speedoc/design-assets";
import ContainerCard from "./containerCard";
import sendEmail from "../../utils/sendEmail";
import { trackCustom } from "../../services/analytics";
import { Remarkable } from "remarkable";
import SubmissionConfirmation from "./submissionConfirmation";
import { GlobalStore } from "../../stores/global";

const markdown = new Remarkable();

export default function ContactFormChronic({ content }) {
  const {
    currentCountryCode: countryCode,
    currentCountry: { phoneNumberText, phoneNumberLink }
  } = GlobalStore.useState(c => c);
  const { title, description, fields = [], emailTo, emailFrom, subject, parent } = content;

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formHeight, setFormHeight] = useState(undefined);
  const targetRef = useRef();
  const submitRef = useRef(null);
  const [error, setError] = useState(false);

  const initialState = {
    email: "",
    name: "",
    phone: "",
    condition: ""
  };

  const [formData, setFormData] = useState(initialState);

  const handleInputChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    if (formData.email.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)) {
      try {
        await sendEmail(formData, {
          fields: fields.map(({ name }) => name),
          to: emailTo,
          from: emailFrom,
          subject,
          parent
        });
        setFormHeight(targetRef.current.offsetHeight);
      } catch (err) {
        console.log(err);
      } finally {
        trackCustom("Lead", countryCode, { email: formData.email });
        setError(false);
        setIsSubmitting(false);
        setIsSubmitted(true);
        setFormData({ ...initialState });
      }
    } else {
      setError("Please enter a valid email.");
      setIsSubmitting(false);
    }
  };

  const handleBackClick = () => {
    setIsSubmitted(false);
  };

  return (
    <div id="contactFormChronic">
      <ContainerCard>
        {!isSubmitted ? (
          <div className="container" ref={targetRef}>
            <div className="textSection">
              <div className="title">{title}</div>
              {description ? (
                <div className="description" dangerouslySetInnerHTML={{ __html: markdown.render(description) }} />
              ) : (
                <div className="description">
                  Send us an enquiry or call us at <br />
                  <a href={phoneNumberLink}>
                    <strong> {phoneNumberText}</strong>
                  </a>
                  . <br /> We will get back to you within the next two (2) working days.
                </div>
              )}
            </div>
            <form className="formSection" onSubmit={handleSubmit} ref={submitRef}>
              <Input
                className="sm"
                id="name"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleInputChange}
              />
              <Input
                className="sm"
                id="phone"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleInputChange}
              />
              <Input
                className={`sm ${error && error.includes("email") ? "error" : ""}`}
                id="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleInputChange}
              />
              <Input
                className="sm"
                id="chronicCondition"
                name="condition"
                placeholder="Chronic Condition"
                value={formData.condition}
                onChange={handleInputChange}
              />
            </form>
            <div className="buttonSection">
              <Button onClick={handleSubmit} disabled={isSubmitting} className="primary sm">
                {isSubmitting ? "Please wait..." : content.buttonText}
              </Button>
              {error ? <p className="errorMessage">{error}</p> : null}
            </div>
          </div>
        ) : (
          <SubmissionConfirmation formHeight={formHeight} handleBackClick={handleBackClick} />
        )}
      </ContainerCard>
    </div>
  );
}
